module.exports = __webpack_public_path__ + "media/water.76f52d36.svg";